import map from '@/api/map';

const state = {
  guidelist: [
    // {
    //   icon: require('@/assets/images/logout.png'),
    //   id: 'test1',
    //   point: [485, 130],
    // },
  ],
};
const actions = {
  getGuidelist({ commit }, params) {
    return new Promise((resolve, reject) => {
      map
        .getGuidelist(params)
        .then((res) => {
          console.log('store---res-----', res);
          commit('updateGuidelist', res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
const getters = {};

const mutations = {
  updateGuidelist(state, val) {
    state.guidelist = val;
  },
};
export default {
  state,
  actions,
  getters,
  mutations,
};
